import { createFileRoute } from '@tanstack/react-router';
import PersonalDataLocation from '@/features/account/profile/personal-data/location';

export const Route = createFileRoute('/perfil/dados-pessoais/localidade')({
  component: PersonalDataLocation,
  staticData: { subtitle: 'Localidade' },
});
